/*
 * @Descripttion: 封装数据请求
 * @Author: juanjuanhui
 * @Date: 2021-05-17 09:25:08
 * @LastEditors: zhaowh zhaowh@example.com
 * @LastEditTime: 2023-09-19 10:18:51
 */
import axios from "axios";
import { Message,Loading } from "element-ui";
import qs from "qs";
import { admParam } from "api/base";
import store from "@/store";
import JSONBIG from 'json-bigint';

// 1.创建新的axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 60000,
  transformResponse:[function(data){
    try{
      return JSONBIG.parse(data)
    }catch(err){
      return data
    }
  }]
});
// 2.请求拦截器
service.interceptors.request.use(
  (config) => {
    const accessToken =
      store.state.accessToken || localStorage.getItem("accessToken");
    if (accessToken) {
      config.headers.accessToken = accessToken;
    }
    // 发请求前做的一些处理，数据转化，配置请求头等，根据需求去添加
    // config.headers = {
    //   "Content-Type": "application/x-www-form-urlencoded",
    // };

    // 判断请求的类型
    // 如果是post请求就把默认参数拼到data里面
    // 如果是get请求就拼到params里面
    if (config.method === "post") {
      let contentType = config.contentType;
      if (contentType && contentType == "application/x-www-form-urlencoded") {
        let data = qs.parse(config.data);
        config.data = qs.stringify({
          // ...admParam(),
          ...data,
        });
        config.headers = {
          "Content-Type": contentType,
        };
      } else {
        let data = config.data;
        config.data = {
          // ...admParam(),
          ...data,
        };
      }
    } else if (config.method === "get") {
      config.params = {
        // ...admParam(),
        ...config.params,
      };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 3.响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.status != 1 && res.status != 200 ) {
      Message({
        message: res.errMsg || res.message || "Error",
        type: "error",
        duration: 2000,
      });
      return Promise.reject(new Error(res.errMsg || res.message || "Error"));
    } else {
      return res;
    }

  },
  (error) => {
    // if (axios.isCancel(thrown)) {
    // } else {
    // }
    Message({
      message: error.errMsg,
      type: "error",
      duration: 2000,
    });
    return Promise.reject(error);
  }
);
export default service;
